// extracted by mini-css-extract-plugin
export default {"container":"jZ-z","list":"kZ-z"};